export enum enumDefaultAccessGroup {
  Dev= 1,
  User,
  OpenUser,
  NetworkUser,
  Business
}

export namespace enumDefaultAccessGroup {
  export function values() {
    return Object.keys(enumDefaultAccessGroup).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}

